__turbopack_context__.v({
  "cooked": "_9Fbd6G_cooked",
  "detailsFadeIn": "_9Fbd6G_detailsFadeIn",
});
